import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';


import logo from "../../../../images/safe-logo-login.svg";
import { Box, CircularProgress, Grid } from '@mui/material';
import db from "../../../../api/mongodb";
import "./ProjectInvitePopup.scss";



const ProjectInvitePage = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [isLoading2, setIsLoading2] = useState(false)


    const { id } = useParams()
    const [invite, setInvite] = useState({})
    const navigate = useNavigate();


    useEffect(() => {
        if(isLoading){
            apiCall()
        }
    }, [isLoading])

    const apiCall = () => {
        db.get(`/api/projects/viewInvitation/${id}`, {
            // headers: {
            //     Authorization: `${localStorage.getItem("token")}`,
            // },
        }).then(
            (response) => {
                console.log(response.data)
                // setSafeAPs(response.data)
                setInvite(response.data)
                setIsLoading(false)

            },
            (error) => {
                console.log(error.response.status)
                if (error.response.status === 403) {
                    navigate(`/`)

                } else {
                    if(error.response.status === 401){
                        const currentUrl = window.location.href;
                        navigate(`/?redirectLink=${currentUrl}`)
                    }else{
                        

                        navigate(`/projects/active`)

                    }
                }


            }
        );


    }

    const acceptInvite = () => {
        setIsLoading2(true)

        db.put(`/api/projects/acceptInvitation/${id}`, {
            // headers: {
            //     Authorization: `${localStorage.getItem("token")}`,
            // },
        }).then(
            (response) => {
                navigate(`/projects/profile/${invite.project._id}`)

            },
            (error) => {
                // console.log(error)
                navigate(`/projects/active`)
                


            }
        );
    }

    const rejectInvite = () => {
        setIsLoading2(true)
        db.put(`/api/projects/rejectInvitation/${id}`, {
            // headers: {
            //     Authorization: `${localStorage.getItem("token")}`,
            // },
        }).then(
            (response) => {
                navigate(`/projects/active`)
                

            },
            (error) => {
                // console.log(error)
                // if (error.response.status === 403) {
                //     navigate(`/`)

                // } else {
                //     const currentUrl = window.location.href;
                //     navigate(`/?redirectLink=${currentUrl}`)
                // }
                navigate(`/projects/active`)


            }
        );

    }
    return (
        <div className="login-background">
            <div className="login-card" style={{ paddingBottom: "5px", height: "50px", width:"500px" }}>
                <Link to="/" className="safe-login-logo">
                    <img src={logo} alt="logo" width={200} style={{ paddingTop: "25px" }} />
                </Link>

                {
                    isLoading ?
                        <CircularProgress size={30}/> :
                        <Box className="login-form" autoComplete="on" noValidate>
                            <p style={{ color: "#011936", }}>
                                You have been invited to the <b>{invite.project.formData.projectName}</b> project by {invite.sender.formData.firstName + ' ' + invite.sender.formData.lastName}
                            </p>

                            <Grid container columnSpacing={2}>
                                <Grid item xs={6}>
                                    <Button
                                        className="login btn-primary"
                                        variant="primary"
                                        type="submit"
                                        onClick={acceptInvite}
                                    >
                                        Accept Invite
                                    </Button>
                                </Grid>
                                <Grid item xs={6}>
                                    <Button
                                        className="reject btn-primary"
                                        variant="primary"
                                        type="submit"
                                        onClick={rejectInvite}
                                    >
                                        Reject Invite

                                    </Button>
                                </Grid>
                            </Grid>
                            <br/>
                            {
                                isLoading2&&
                                <CircularProgress size={20}/>

                            }



                        </Box>
                }


            </div>
            <p className="copyright-text">
                © Copyright {new Date().getFullYear()} SAFE Design Technologies Inc.
            </p>
        </div>

    );
};

export default ProjectInvitePage;